import { AdminInsightEmptyReason } from '../types/dashboard'

// Human-readable copy for each empty-state reason the restaurant-admin insight endpoints return, so
// the UI can explain "no data yet, and here's why" instead of showing a bare blank panel.
const MESSAGES: Record<AdminInsightEmptyReason, string> = {
  RESTAURANT_NOT_FOUND:
    "We couldn't find your restaurant profile yet. Finish setting up your restaurant to see this.",
  NO_MENU_ITEMS: 'Add items to your menu to unlock this comparison.',
  NO_COMPETITORS_IN_AREA:
    'No other restaurants were found in your area yet, so there’s nothing to compare against.',
  NO_MATCHING_DISHES:
    'We found nearby restaurants, but none of their dishes matched yours by name yet.',
  MISSING_FIPS: 'Select an area on the map to see local insights.',
  CENSUS_DATA_UNAVAILABLE:
    'Local area data isn’t available for this location yet.',
}

/**
 * Maps an empty-state reason to display copy. Returns a generic fallback for an unknown/blank reason
 * so the UI never shows a raw code.
 */
export const emptyReasonMessage = (
  reason?: AdminInsightEmptyReason | null,
): string => {
  if (reason && MESSAGES[reason]) {
    return MESSAGES[reason]
  }
  return 'No data available yet.'
}
